export enum AuthVerifyCodeActions {
  VERIFY_CODE,
  RESEND_VERIFY_CODE,
}
